import { K1_CLIENTS_KEY } from "./ClientsPage.types";
import type { ClientScope } from "./ClientsPage.types";

export const getClientScopePayload = (scope: ClientScope) =>
  scope === "k1" ? { Key: K1_CLIENTS_KEY } : {};

export const getClientScopeQuery = (scope: ClientScope) =>
  scope === "k1" ? `?Key=${encodeURIComponent(K1_CLIENTS_KEY)}` : "";
